import { createContext } from 'react';
import RootStore from './rootStore';

const rootStore = new RootStore();

const stores = {
  rootStore,
};

export default stores;

if (process.env.IS_DEVELOPMENT || process.env.IS_STAGING) {
  window.__STORES__ = stores;
}

export const storesContext = createContext(stores);
